<div *ngIf="sourcePage != 'profile'">
  <p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
</div>
<div *ngIf="sourcePage != 'profile'">
  <h1>Payee Documents</h1>
</div>

<main class="home-payeedocument">
  <div *ngIf="sourcePage != 'profile'" class="instruction-text">Manage documents and files for this payee.</div>
  <section style="margin-top:15px;">
    <div *ngIf="sourcePage != 'profile'" class="p-grid">
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4"><label>Name</label></div>
          <div class="p-col-12 p-md-8 p-lg-8" style="padding-top:18px;">{{payee.fullName}} </div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4"><label>Status</label></div>
          <div class="p-col-12 p-md-8 p-lg-8" style="padding-top:18px;">{{status}}</div>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4"><label>Document Type</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown id="documentType" name="documentType" [showClear]="true" [options]="documentTypeOptions" [(ngModel)]="searchOption.documentType"
                        placeholder="Select..."></p-dropdown>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-md-6 p-lg-6">
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4"><label>Calendar Year</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="calendaryear" [style]="{'overflow':'visible', 'width':'100%'}" [options]="yearDropDown" [(ngModel)]="searchOption.year" placeholder="Select..."></p-dropdown>
          </div>
        </div>
      </div>

      <div class="p-col-12 p-md-6 p-lg-6"><!-- *ngIf="documentType =='Paystub'"-->
        <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4"><label>Check Date</label></div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-calendar id="checkDate" name="checkDate" dataType="string" [dateFormat]="Format.PcalendarDate" icon="fa fa-calendar" showIcon="true" [(ngModel)]="searchOption.checkDate"
                        [monthNavigator]="true" [yearNavigator]="true" readonlyInput="true">
            </p-calendar>
          </div>
          <div class="p-col-12 p-md-2 p-lg-2"></div>
          <div class="p-col-12 p-md-10 p-lg-10">
            <button pButton type="button" class="inaction-secondary" icon="fa fa-eraser" label="Clear" pTooltip="Clear" style="display:inline-block;" (click)="onClickClearSearchOption()"></button>
            <button pButton type="button" class="action-secondary" icon="fa fa-search" label="Go" style="display:inline-block;" (click)="onClickSearchPD(searchOption)"></button>
          </div>
        </div>
      </div>
    </div>

    <!--datatable-->
    <app-data-table [columns]="payeeDocumentsTableColumns" [value]="payeeDocuments" sortField="'checkDate'">

      <ng-template #actionTemplate let-row="row">
        <button *ngIf="row.taxFormRefId" pButton type="button" class="icon-action" icon="fa fa-download" pTooltip="Download Document" tooltipPosition="top" (click)="onClickDownload(row)"></button>
        <button pButton type="button" class="icon-action" icon="fa fa-eye" pTooltip="View Document" tooltipPosition="top" (click)="onClickView(row)"></button>
      </ng-template>
    </app-data-table>
    <div *ngIf="sourcePage != 'profile'" class="p-col-12">
      <div class="p-col-12 p-md-6 p-lg-6" style="text-align:left;">
        <button pButton type="button" class="action-secondary" icon="fa fa-arrow-circle-left" label="Return to Main" style="margin-bottom: 100px;" (click)="goToPayeeMainUI()"></button>
      </div>
    </div>
    <div class="main-clear"></div>
  </section>
</main>
